import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderDownload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderDownload"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H10.5352L12.5352 6H22V20H2V3ZM12 18.4142L8.08579 14.5L9.5 13.0858L11 14.5858V10H13V14.5858L14.5 13.0858L15.9142 14.5L12 18.4142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderDownload;
